// has543 — persist a dual-admin's preferred Honors/Scholars landing side in the browser.
// Only Honors/Scholars *admins on both sides* ever see the toggle, so this preference is only
// meaningful for them; single-side users always land on their own side regardless of any stored value.
//
// Storage is best-effort: any localStorage failure (privacy mode, quota, disabled) degrades to
// "no stored preference" rather than throwing (mirrors ui/src/util/DarkModeToggle.js).

import { PROGRAMS } from '../constants';

export const PREFERRED_PROGRAM_SIDE_KEY = 'hs.preferredProgramSide';

const VALID_SIDES = [PROGRAMS.HONORS.KEY, PROGRAMS.SCHOLARS.KEY];

/**
 * Read the stored preferred program side.
 * @returns {string|null} PROGRAMS.HONORS.KEY | PROGRAMS.SCHOLARS.KEY, or null when unset/invalid.
 */
export function getPreferredProgramSide() {
  try {
    const value = localStorage.getItem(PREFERRED_PROGRAM_SIDE_KEY);
    return VALID_SIDES.includes(value) ? value : null;
  } catch (e) {
    console.error('Error reading preferred program side from localStorage:', e);
    return null;
  }
}

/**
 * Persist the preferred program side. Ignores invalid values.
 * @param {string} side - PROGRAMS.HONORS.KEY | PROGRAMS.SCHOLARS.KEY
 * @returns {boolean} true when written.
 */
export function setPreferredProgramSide(side) {
  if (!VALID_SIDES.includes(side)) { return false; }
  try {
    localStorage.setItem(PREFERRED_PROGRAM_SIDE_KEY, side);
    return true;
  } catch (e) {
    console.error('Error writing preferred program side to localStorage:', e);
    return false;
  }
}

/**
 * The effective default landing to display in the preference control: the stored side, or Honors
 * when nothing is stored (Honors is the default landing per has543).
 * @returns {string} PROGRAMS.HONORS.KEY | PROGRAMS.SCHOLARS.KEY
 */
export function getEffectiveDefaultProgramSide() {
  return getPreferredProgramSide() ?? PROGRAMS.HONORS.KEY;
}
